import { AxiosRequestConfig } from 'axios';

export default function Api(optionsOrBaseUrl?: string | AxiosRequestConfig): any;

export default function Api(...params: any[]) {
  return (target: any) => {
    const original = target;

    const f: any = (...args: any[]) => {
      if (params[0]) {
        if ((typeof params[0]) === 'string') {
          original.prototype.axiosOptions = {
            baseURL: params[0]
          };
        } else {
          original.prototype.axiosOptions = params[0];
        }
      }
      const instance = original.apply(original.prototype, args);
      return instance;
    };

    f.prototype = original.prototype;
    return f;
  };
}
